import { useMemo, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import Select from "react-select";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { Controller } from "react-hook-form";
import { useSelector } from "react-redux";
import { fetchMembershipDropdown } from "services/membershipCard";

const MembershipDropdown = ({
  errors,
  control,
  required,
  defaultValue,
  setValue,
  onMembershipChange,
}) => {
  const login = useSelector((state) => state.jwtAuthreducer);

  const {
    data: memberships,
    isLoading,
    isError,
  } = useQuery(["fetch-memberships"], fetchMembershipDropdown, {
    staleTime: DROPDOWN_STALE_TIME,
  });

  const options = useMemo(() => {
    return (
      memberships?.data?.map((item) => ({
        value: item?.id,
        label: item?.membership_card_name,
        annual_fees: item?.annual_fees,
        discount_percentage: item?.discount_percentage,
        zone_id: item?.zone_id,
      })) || []
    );
  }, [memberships]);

  useEffect(() => {
    if (options.length > 0 && defaultValue && setValue) {
      const selectedOption = options.find((opt) => opt.value === defaultValue);
      if (selectedOption) {
        setValue("membership_id", selectedOption.value);
      }
    }
  }, [options, defaultValue, setValue]);

  if (isLoading) return <div>Loading...</div>;
  if (isError) return <div>Error loading memberships</div>;

  return (
    <Controller
      name="membership_id"
      control={control}
      defaultValue={defaultValue || ""}
      rules={{ required: required ? "Membership is required" : false }}
      render={({ field }) => (
        <Select
          {...field}
          options={options}
          isClearable
          placeholder="Select Membership"
          value={options.find((option) => option.value === field.value) || null}
          onChange={(selectedOption) => {
            field.onChange(selectedOption?.value || "");

            if (selectedOption && setValue) {
              setValue("annual_fees", selectedOption.annual_fees || "");
              setValue(
                "discount_percentage",
                selectedOption.discount_percentage || ""
              );
              setValue("zone_id", selectedOption.zone_id || "");
            } else if (setValue) {
              setValue("annual_fees", "");
              setValue("discount_percentage", "");
            }

            if (onMembershipChange) {
              onMembershipChange(selectedOption);
            }
          }}
        />
      )}
    />
  );
};

export default MembershipDropdown;
